import { TableConfig } from 'models/general';
import { queryKeys } from 'utils/query';
import { GroupSettingsColumns } from 'components/Table/Columns/GroupSettingsColumns';
import { TableBody } from 'components/Table/TableBody/TableBody';
import { getGroupSettings } from 'services/groups';
import { SettingsListFilters } from 'components/Table/Filters/SettingsListFilters';
import { GroupEnlistment } from 'models/groups';
import { DataFieldNames } from './GroupSettingsTable.config';

export const GroupSettingsTable = () => {
  const settingsListConfig: TableConfig = {
    queryKey: queryKeys.groupSettings,
    dataFieldNames: DataFieldNames,
    defaultSort: `${DataFieldNames.name}`,
  };

  return (
    <TableBody<GroupEnlistment>
      getData={getGroupSettings}
      getColumns={GroupSettingsColumns}
      config={settingsListConfig}
      filterBar={<SettingsListFilters config={settingsListConfig} />}
    />
  );
};
